/**
 * Stripe Checkout return on the app origin.
 * checkout=success stays in the URL until the Supabase session is loaded,
 * verify has run, and the short profile poll has finished.
 */

const CHECKOUT_POLL_ATTEMPTS = 5;
const CHECKOUT_POLL_WAIT_MS = 1000;

function readCheckoutQuery(search) {
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
  const status = params.get('checkout');
  if (status !== 'success' && status !== 'canceled') return null;
  return {
    status,
    sessionId: params.get('session_id') || '',
  };
}

function withoutCheckoutQuery(href) {
  const raw = String(href || '');
  const hashIndex = raw.indexOf('#');
  const hash = hashIndex >= 0 ? raw.slice(hashIndex) : '';
  const beforeHash = hashIndex >= 0 ? raw.slice(0, hashIndex) : raw;
  const queryIndex = beforeHash.indexOf('?');
  const path = queryIndex >= 0 ? beforeHash.slice(0, queryIndex) : beforeHash;
  const params = new URLSearchParams(queryIndex >= 0 ? beforeHash.slice(queryIndex + 1) : '');
  params.delete('checkout');
  params.delete('session_id');
  const next = params.toString();
  return path + (next ? `?${next}` : '') + hash;
}

/**
 * Success is verified only after the auth session exists.
 * The URL is stripped after that work finishes, or immediately for cancel.
 */
function nextCheckoutAction({ authReady, session, pending, handled }) {
  if (!pending) return { verify: false, strip: false };
  if (pending.status === 'canceled') {
    return { verify: false, strip: !handled };
  }
  if (pending.status !== 'success') return { verify: false, strip: false };
  if (!authReady || !session) return { verify: false, strip: false };
  if (!handled) return { verify: true, strip: false };
  return { verify: false, strip: true };
}

async function pollSubscriptionProfile(load, options) {
  const attempts = options && options.attempts ? options.attempts : CHECKOUT_POLL_ATTEMPTS;
  const waitMs = options && options.waitMs != null ? options.waitMs : CHECKOUT_POLL_WAIT_MS;
  const sleep = options && options.sleep
    ? options.sleep
    : (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const allows = options && options.allows ? options.allows : () => false;

  for (let i = 0; i < attempts; i += 1) {
    const profile = await load();
    if (allows(profile)) return profile;
    if (i < attempts - 1) await sleep(waitMs);
  }
  return null;
}

module.exports = {
  CHECKOUT_POLL_ATTEMPTS,
  CHECKOUT_POLL_WAIT_MS,
  readCheckoutQuery,
  withoutCheckoutQuery,
  nextCheckoutAction,
  pollSubscriptionProfile,
};
